export default {
  language: 'Language',
  addMultiLang: 'Add Multiple Languages',
  delete: 'Delete',
  save: 'Save',
  addMultiLangModalTitle: 'Member Multilingual Information',
  deleteMultiLangModalTitle: 'Delete Multilingual',
  selectLangWarning: 'Please select at least one language',
  addLangSuccess: 'Language added successfully',
  deleteLangSuccess: 'Language deleted successfully',
  deleteLangFailed: 'Failed to delete language',
  contentRequired: 'Please enter after-sale feedback content',
  saveSuccess: 'Saved successfully',
  saveFailed: 'Failed to save',
  loadFailed: 'Failed to load after-sale feedback content',
  placeholder: 'Please enter after-sale feedback content',
};
